import { FC } from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { Animation, Animations, Modal } from '../../../../stories/molecules';
import { ContainerV2 } from '../../../../stories/atoms/containerV2/ContainerV2';
import { homeTranslations } from '../../../../translations';

export type CelebrationData = {
  widgetName: string;
  targetValue: string;
  updateDate: Date;
};

type CelebrationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  celebrations: CelebrationData[];
};

export const CelebrationModal: FC<CelebrationModalProps> = ({ isOpen, onClose, celebrations }) => {
  const { t } = useTranslation();
  const { celebrationModal } = homeTranslations;

  if (!celebrations.length) return null;

  const formattedDate = format(new Date(celebrations[0].updateDate), 'yyyy-MM-dd');

  const formattedWidgetList = celebrations
    .map(({ widgetName, targetValue }) =>
      t(celebrationModal.widgetName.key, {
        defaultValue: celebrationModal.widgetName.defaultValue,
        widgetName,
        targetValue,
      }),
    )
    .join(', ');

  const subtitle =
    celebrations.length === 1
      ? t(celebrationModal.subtitleForSingle.key, {
          defaultValue: celebrationModal.subtitleForSingle.defaultValue,
          widgetName: formattedWidgetList,
          date: formattedDate,
        })
      : t(celebrationModal.subtitleForMultiple.key, {
          defaultValue: celebrationModal.subtitleForMultiple.defaultValue,
          widgetName: formattedWidgetList,
          date: formattedDate,
        });

  return (
    <Modal isOpen={isOpen} transitionType="grow" ariaDescribedby="celebration-modal" handleClose={onClose}>
      <ContainerV2 padding={[4, 16]} data-testid="celebration-modal-container">
        <Animation
          title={t(celebrationModal.title.key, celebrationModal.title.defaultValue)}
          subtitle={subtitle}
          animation={Animations.HAPPY}
        />
      </ContainerV2>
    </Modal>
  );
};
